import { MutationTree } from 'vuex';
import { LoginRecordState, LoginRecordSearchInfo } from './types';
import * as types from './mutation-types';
import { ErrorDetail } from '../../types';

// エラーをクリアする
const resetErrors = (state: LoginRecordState): void => {
    const searchState = state.search;
    searchState.error = false;
    searchState.errorCode = undefined;
    searchState.errorMsg = undefined;

    const csvState = state.csv;
    csvState.error = false;
    csvState.errorTitle = undefined;
    csvState.errorDetails = undefined;

    const recFileState = state.recFile;
    recFileState.isProcessing = false;
    recFileState.isFetchSuccess = false;
};

export const mutations: MutationTree<LoginRecordState> = {
    // ログイン履歴の一覧取得系
    [types.SEARCH_START](state) {
        resetErrors(state);
        const searchState = state.search;
        searchState.isProcessing = true;
        searchState.isFetchSuccess = false;
    },

    [types.SEARCH_SUCCESS](state, payload: { count: number; login_records: Array<LoginRecordSearchInfo> }) {
        state.loginRecordCount = payload.count;
        state.loginRecords = payload.login_records;

        const searchState = state.search;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = true;
    },

    [types.SEARCH_FAILURE](state, payload: { code: string; message: string }) {
        const searchState = state.search;
        searchState.errorCode = payload.code;
        searchState.errorMsg = payload.message;
        searchState.error = true;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = false;
    },

    // CSV出力系
    [types.CSV_OUTPUT_START](state) {
        resetErrors(state);
        const csvState = state.csv;
        csvState.isProcessing = true;
    },

    [types.CSV_OUTPUT_SUCCESS](state) {
        const csvState = state.csv;
        csvState.isProcessing = false;
    },

    [types.CSV_OUTPUT_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const csvState = state.csv;
        csvState.errorTitle = payload.errorTitle;
        csvState.errorDetails = payload.errorDetails;
        csvState.error = true;
        csvState.isProcessing = false;
    },

    // 作業記録RECファイルの取得系
    [types.REC_FILE_START](state) {
        resetErrors(state);
        const recFileState = state.recFile;
        recFileState.error = false;
        recFileState.errorTitle = undefined;
        recFileState.errorDetails = undefined;
        recFileState.isProcessing = true;
        recFileState.isFetchSuccess = false;
    },

    [types.REC_FILE_SUCCESS](state, payload) {
        state.recFilePath = payload;

        const recFileState = state.recFile;
        recFileState.isProcessing = false;
        recFileState.isFetchSuccess = true;
    },

    [types.REC_FILE_FAILURE](state, payload: { errorTitle: string; errorDetails: Array<ErrorDetail> }) {
        const recFileState = state.recFile;
        recFileState.errorDetails = payload.errorDetails;
        recFileState.errorTitle = payload.errorTitle;
        recFileState.error = true;
        recFileState.isProcessing = false;
        recFileState.isFetchSuccess = false;
    },

    // FATALエラー系
    [types.FATAL_FAILURE](state) {
        const searchState = state.search;
        searchState.isProcessing = false;
        searchState.isFetchSuccess = false;

        const csvState = state.csv;
        csvState.isProcessing = false;

        const recFileState = state.recFile;
        recFileState.isProcessing = false;
        recFileState.isFetchSuccess = false;
    },

    [types.CLEAR_ALL](state) {
        resetErrors(state);
        state.loginRecords = undefined;
        state.loginRecordCount = 0;
        state.recFilePath = undefined;
    },
};
